module.exports = __webpack_public_path__ + "img/Capture-3_3.b6fb1370.png";